import React from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom';
import KeywordInputGroupContainer from '../KeywordInputGroup/KeywordInputGroupContainer';
import { LocationGroup } from '../LocationGroup';
import { FacetDropdown } from '../FacetDropdown';
import { AgeRange } from '../AgeRange';
import { Checkbox } from 'module-tsl-ui-elements';

const MobileFilters = ({ history: { push }, base, checkSubmit, facets, pathname, clearFilters, keywords, searchType,
  selectedFacets, changeQuickFilterValue, changeCheckBoxFilterValue, metadata, mobileFiltersActive }) => {

  const { count } = metadata || { count: 0 };
  const isSupply = searchType === 'supply';
  const isEmbed = searchType === 'embed';
  const quickApplyValue = !!selectedFacets.find( a => a.name === 'applicationType' );
  const FullTimeValue = selectedFacets.find( a => a.name === 'contractTypes' ) && selectedFacets.find( a => a.name === 'contractTypes' ).value && selectedFacets.find( a => a.name === 'contractTypes' ).value.indexOf('Full Time') > -1;
  const PartTimeValue = selectedFacets.find( a => a.name === 'contractTypes' ) && selectedFacets.find( a => a.name === 'contractTypes' ).value && selectedFacets.find( a => a.name === 'contractTypes' ).value.indexOf('Part Time') > -1;
  const NQTTimeValue = selectedFacets.find( a => a.name === 'experiences' ) && selectedFacets.find( a => a.name === 'experiences' ).value && selectedFacets.find( a => a.name === 'experiences' ).value.indexOf('Suitable for NQTs (ECTs)') > -1;

  const showDropdownTitle = !!(count && (facets.locations || []).length > 1);
  const effectiveExcludedCount = (selectedFacets.find(({name}) => name === 'excludedLocations') || { value: [] }).value
    .filter(v => facets.locations.find(l => (l.facetItemPath || '').replace(/^l[0-9]:/, '') === v)).length;
  const selectedCount = (facets.locations || []).length - effectiveExcludedCount;

  return (
    <div className={`top-filters mobile-filters ${isSupply ? 'supply-search' : ''} ${isEmbed ? 'embed-search' : ''} ${mobileFiltersActive ? 'active' : ''}`}>
      <div className="tes-panel tes-panel--slim tes-panel--divider-bottom tes-panel--no-bg">
        <div className="tes-panel__body l-inline-container">
          <div className="l-vcenter l-vcenter--half padding-top-bottom-xs">
            <h2 className="facets__heading-main">Filters applied</h2>
          </div>
          <div className="l-vcenter l-vcenter--half text-right">
            <a className="link link--colored facets__heading-main t-clear-filters"
              onClick={() => clearFilters(push, pathname)} >
              Clear filters
            </a>
          </div>
        </div>
      </div>
      <form
        onSubmit={evt => checkSubmit(evt, push, base, keywords)}
        data-module="search-section"
        data-id="search-jobs"
        id="search-jobs"
        className="clearfix top-filters-form"
      >
        { isSupply && <h2 className="heading heading--xxl margin-bottom-md">
          {count} Supply teacher jobs
        </h2> }
        <div className="row">
          <h3 className="sr-only">Keywords</h3>
          <div className="col-md-4 padding-right-none">
            <KeywordInputGroupContainer submit={evt => checkSubmit(evt, push, base, keywords)}/>
          </div>
          <h3 className="sr-only">UK postcode or current location</h3>
          <div className="col-md-8">
            <LocationGroup
              placeholder={`${(facets.locations || []).length} locations selected.`}
              showDropdownTitle={showDropdownTitle}
              selectedCount={selectedCount}
              includedTowns={(facets.locations || [])}
            />
          </div>
        </div>
        { !isSupply && <div className="three-facets">
          <FacetDropdown
            placeholder="Position"
            fieldName="positions"
            groupLabel="Positions"
            className="margin-bottom-xml"
            labelKey="label"
            clearable={false}
            values={(facets.positions || [])} />
          <FacetDropdown
            placeholder="Workplaces"
            fieldName="workplaces"
            groupLabel="Workplaces"
            className="margin-bottom-xml"
            clearable={false}
            values={(facets.workplaces || [])} />
          <FacetDropdown
            placeholder="Subject"
            fieldName="subjects"
            groupLabel="Subjects"
            className="margin-bottom-md"
            clearable={false}
            values={(facets.subjects || [])} />
        </div> }
        <div className="more-filters">
          <div className="facet-selector">
            <div className="row margin-bottom-md">
              { !isSupply && <div className="col-md-6 padding-right-none">
                <label className="dropdown-label">Contract term</label>
                <div className="ms" data-tip data-for="contractTerms">
                  <FacetDropdown
                    placeholder="Choose"
                    fieldName="contractTerms"
                    groupLabel="Contract term"
                    clearable={false}
                    values={(facets.contractTerms || [])} />
                </div>
              </div> }
              <AgeRange />
            </div>
            <div className="row padding-right-md">
              <div className="col-xs-6 padding-right-none">
                <Checkbox
                  id="FullTimeCheckBox"
                  caption="toggle"
                  checked={FullTimeValue}
                  onChange={(e) => changeCheckBoxFilterValue(e.target.checked, { facets, keywords, base, push, key: 'contractTypes', value: 'Full Time' })}
                />
                <label htmlFor="FullTimeCheckBox" className="checkbox-label">Full time jobs</label>
              </div>
              <div className="col-xs-6 padding-none">
                <Checkbox
                  id="NQTCheckBox"
                  caption="toggle"
                  checked={NQTTimeValue}
                  onChange={(e) => changeCheckBoxFilterValue(e.target.checked, { facets, keywords, base, push, key: 'experiences', value: 'Suitable for NQTs (ECTs)' })}
                />
                <label htmlFor="NQTCheckBox" className="checkbox-label">Suitable for NQT's</label>
              </div>
              <div className="col-xs-6 padding-right-none">
                <Checkbox
                  id="PartTimeCheckBox"
                  caption="toggle"
                  checked={PartTimeValue}
                  onChange={(e) => changeCheckBoxFilterValue(e.target.checked, { facets, keywords, base, push, key: 'contractTypes', value: 'Part Time' })}
                />
                <label htmlFor="PartTimeCheckBox" className="checkbox-label">Part time jobs</label>
              </div>
              { !searchType && <div className="col-xs-6 padding-none">
                <Checkbox
                  id="quickApplyCheckBox"
                  caption="toggle"
                  checked={quickApplyValue}
                  onChange={(e) => changeQuickFilterValue(e.target.checked, { facets, keywords, base, push })}
                />
                <label htmlFor="quickApplyCheckBox" className="checkbox-label">Quick Apply jobs</label>
              </div>}
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

MobileFilters.propTypes = {
  pathname: PropTypes.string.isRequired,
  keywords: PropTypes.string.isRequired,
  facets: PropTypes.object.isRequired,
  clearFilters: PropTypes.func,
  changeSelectedMoreFilter: PropTypes.func,
  selectedFacets: PropTypes.array,
  searchType: PropTypes.string,
  loading: PropTypes.bool,
  locationBreadcrumb: PropTypes.array,
  mobileFiltersActive: PropTypes.bool,
  experiments: PropTypes.object,
  metadata: PropTypes.object,
  history: PropTypes.shape({
    listen: PropTypes.func.isRequired
  }).isRequired
};

MobileFilters.defaultProps = {
  metadata: {
    count: 0
  }
};

export default withRouter(MobileFilters);
